export default __webpack_public_path__ + "static/media/surveyor_green.ce8d51db.svg";